import React from "react";

import { LogUnionRowItem } from "@common/components/MasterTable/models/MasterTableModel";
import { getActivityHistoryCellStyle, isCellError } from "@common/components/ShakeTable/ui/activityHistory/DomainCell";
import { BaseCell } from "@common/components/ShakeTable/ui/BaseCell";
import { LogType, NetworkRequest } from "@common/models/eventTracking";
import { vars } from "@common/styles";
import { getStatusColor } from "@main/pages/shared/components/ActivityHistoryTable/LogDetails/NetworkRequestDetails";
import { CellContext } from "@tanstack/react-table";

interface StatusCellProps {
  // eslint-disable-next-line
  info: CellContext<LogUnionRowItem, any>;
}

const StatusCell = ({ info }: StatusCellProps) => {
  const item = info.row.original;
  if (!item) return null;

  const isError = isCellError(info);

  return (
    <BaseCell
      style={getActivityHistoryCellStyle(isError)}
      withBorder={info.table.getSelectedRowModel()?.rows[0]?.index - 1 === info.row.index || info.row.getIsSelected()}
    >
      {info.row.original.instance_type === LogType.NETWORK_REQUEST ? getStatus(info.row.original, isError) : ""}
    </BaseCell>
  );
};

const getStatus = (log: NetworkRequest, isError: boolean) => {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div
        style={{
          width: "0.9rem",
          height: "0.9rem",
          borderRadius: "50%",
          backgroundColor: getStatusColor(log.status_code),
          marginRight: "0.4rem",
          color: `${vars.colors.white}`,
        }}
      />
      <p style={{ color: isError ? vars.colors.red : vars.colors.grey30 }}>{log.status_code}</p>
    </div>
  );
};

export { StatusCell };
